import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject, tap, map } from 'rxjs';
import { Onboarding } from '../models/onboarding.model';

@Injectable({
  providedIn: 'root'
})
export class OnboardingService {
  
  private baseUrl = environment.baseUrl;

  private onboardingSubject = new BehaviorSubject<Onboarding | null>(null);

  constructor(private http: HttpClient) {}

  get onboarding$(): Observable<Onboarding | null> {
    return this.onboardingSubject.asObservable();
  }

  completeOnboarding(biggestChallenge: string, userType: string, registrationGoal: string, activatePremiumTrial: boolean): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/user/complete-onboarding`, { biggestChallenge, userType, registrationGoal, activatePremiumTrial });
  }

  loadOnboarding() {
    this.http.get<Onboarding>(`${this.baseUrl}/onboarding`).pipe(
      map((data) => Onboarding.constructOnboarding(data))
    ).subscribe((onboarding) => this.onboardingSubject.next(onboarding));
  }

  updateOnboarding(onboarding: Onboarding) {
    this.onboardingSubject.next(onboarding);
    this.http.put<any>(`${this.baseUrl}/onboarding`, onboarding).subscribe();
  }
}
